var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"privacy-and-security"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"my-5"},[_c('H1',[_vm._v("\n        Privacy And Security\n      ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }